import React from 'react'
import { motion } from 'framer-motion'
import { ArrowRight } from 'lucide-react'
import { HOW_IT_WORKS_STEPS } from '../constants'
import Container from './Container'
import AnimatedSection from './AnimatedSection'
import { staggerContainerVariants, staggerItemVariants } from '../utils/animations'

/**
 * HowItWorks - 3-step process section
 */

const HowItWorks: React.FC = () => {
  return (
    <section className="bg-secondary-light py-24 md:py-32">
      <Container size="xl">
        {/* Section Header */}
        <AnimatedSection className="mx-auto mb-16 max-w-3xl text-center">
          {/* Section Label */}
          <span className="section-label mb-4 block">Proceso</span>
          <h2 className="accent-line-center mb-6 text-3xl font-bold text-primary md:text-4xl lg:text-5xl">
            Así avanzas en 3 pasos
          </h2>
        </AnimatedSection>

        {/* Steps Grid */}
        <motion.div
          className="grid grid-cols-1 gap-8 md:grid-cols-3 lg:gap-12"
          variants={staggerContainerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-100px' }}
        >
          {HOW_IT_WORKS_STEPS.map((step, index) => (
            <motion.div key={step.id} variants={staggerItemVariants} className="relative">
              {/* Connector Line (hidden on mobile) */}
              {index < HOW_IT_WORKS_STEPS.length - 1 && (
                <div className="absolute left-full top-16 hidden h-0.5 w-full -translate-x-1/2 bg-accent/20 md:block" />
              )}

              {/* Step Card */}
              <div className="card-hover h-full rounded-xl border border-border-light bg-white p-8">
                {/* Step Number */}
                <div className="shadow-luxury mb-6 flex h-16 w-16 items-center justify-center rounded-xl bg-accent">
                  <span className="text-2xl font-bold text-white">{step.number}</span>
                </div>

                {/* Title */}
                <h3 className="mb-4 text-xl font-bold text-primary">{step.title}</h3>

                {/* Description */}
                <p className="leading-relaxed text-text-secondary">{step.description}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>

        {/* CTA */}
        <AnimatedSection className="mt-12 text-center" delay={0.3}>
          <a
            href="#contacto"
            className="group inline-flex items-center justify-center rounded-lg bg-primary px-8 py-4 font-semibold text-white transition-all duration-300 hover:bg-primary-light hover:text-primary focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2"
          >
            Quiero hablar con un asesor
            <ArrowRight className="btn-arrow ml-2 h-5 w-5" aria-hidden={true} />
          </a>
        </AnimatedSection>
      </Container>
    </section>
  )
}

export default HowItWorks
